import { ApiError, ErrorType, setErrorPopupData, useChipSetStore, usePlayerStore } from '@slot-nx/core'
import { IBuyBonusApi } from '../api/buyBonusApi'
import { useGameStore } from '../../game/store/GameStore'
import { useGodziDropStore } from '../../godziDrop/store/godziDropStore'

export class BuyBonusService {
  private _api: IBuyBonusApi

  constructor(api: IBuyBonusApi) {
    this._api = api
  }

  async buyBonus() {
    const freeGameType = useGameStore.getState().currentFreeGameType
    const chipSetStore = useChipSetStore.getState()
    const stake = chipSetStore.computed.currentStake
    // const currentBalance = usePlayerStore.getState().balance
    // const payStake = getPayStake(stake, freeGameType)

    try {
      // if (currentBalance < payStake) {
      //   throw new ApiError(ErrorType.InsufficientBalance)
      // }
      const { balance, mainGame, freeGame, totalPayout, godziDrop, settledBalance } = await this._api.buyBonus({
        stake,
        freeGameType,
      })

      usePlayerStore.setState({
        balance: balance,
        lastSettledBalance: settledBalance,
      })

      useGameStore.setState({
        gameResult: {
          mainGame: mainGame,
          totalPayout: totalPayout,
          freeGame: freeGame,
        },
        freeGameType: mainGame.freeGameType,
        multiplierReelInfo: mainGame.multiplierReel,
      })

      useGodziDropStore.setState({
        godziResult: godziDrop,
        godziDropFreeGameType: godziDrop.roundGameResult[0]?.mainGame.freeGameType,
      })
    }
    catch (e) {
      // console.log(e)
      if (e instanceof ApiError && e.type === ErrorType.InsufficientBalance) {
        setErrorPopupData(ErrorType.InsufficientBalance)
      }
      else {
        setErrorPopupData(ErrorType.SystemError)
      }
      throw e
    }
  }
}
